import { ToolCallInfo } from '~/components/AiChat/AiChatContext';
import type { ChatMessage } from '~/components/AiChat/AiChatContext';
import { CustomerContext } from '~/components/AiChat/chatModes';

import { json_headers, request } from './common';

export interface ChatRequest {
  context: CustomerContext;
  messages: Array<ChatMessage>;
}

export interface ChatResponse {
  content: string;
  toolCalls: Array<ToolCallInfo>;
  responseId: string | null;
}

interface ResponsesApiOutput {
  type: string;
  role?: string;
  content?: Array<{ type: string; text: string }>;
}

interface ResponsesApiResult {
  id: string;
  output: Array<ResponsesApiOutput>;
  toolCalls?: Array<ToolCallInfo>;
  usage?: {
    input_tokens: number;
    output_tokens: number;
    total_tokens: number;
  };
}

export async function sendChatMessage(payload: ChatRequest): Promise<ChatResponse> {
  const userMessages = payload.messages
    .filter((m) => m.role !== 'system')
    .map(({ role, content }) => ({ role, content }));

  const result: ResponsesApiResult = await request('/api/openai/responses', {
    method: 'POST',
    headers: json_headers,
    body: JSON.stringify({ messages: userMessages, context: payload.context }),
  });

  const messageOutput = result.output?.find((o) => o.type === 'message' && o.role === 'assistant');
  const textContent = messageOutput?.content?.find((c) => c.type === 'output_text');

  return {
    content: textContent?.text || 'No response received.',
    toolCalls: result.toolCalls || [],
    responseId: result.id || null,
  };
}

export async function transcribeAudio(audioBlob: Blob): Promise<string> {
  const formData = new FormData();
  formData.append('file', audioBlob, 'recording.webm');

  const result = await request('/api/openai/audio/transcriptions', {
    method: 'POST',
    body: formData,
  });

  return result?.text || '';
}
